import React from 'react';
import { Link } from 'react-router-dom';
import { useGiwahs } from '../context/GiwahsContext';
import { getSupplierById } from '../data/mockData';
import SupplierCard from '../components/SupplierCard';
import RecentlyViewedStrip from '../components/RecentlyViewedStrip';
import SEO from '../components/SEO';

const SavedSuppliers = () => {
  const { savedSuppliers, hydrating } = useGiwahs();
  const items = savedSuppliers.map(getSupplierById).filter(Boolean);

  if (hydrating) {
    return (
      <div data-testid="saved-loading" className="bg-white">
        <div className="mx-auto max-w-2xl px-5 py-24 text-center md:py-32">
          <span className="label-overline text-neutral-500">Loading your saved suppliers…</span>
        </div>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div data-testid="saved-empty" className="bg-white">
        <SEO title="Saved Suppliers" description="Your bookmarked suppliers on GIWAHS." noindex />
        <div className="mx-auto max-w-2xl px-5 py-24 text-center md:py-32">
          <span className="label-overline">/ Saved Suppliers</span>
          <h1 className="mt-4 font-display text-4xl tracking-tighter md:text-6xl" style={{ fontWeight: 700 }}>Your bookmarks live here.</h1>
          <p className="mt-5 text-neutral-700">Tap the bookmark icon on any supplier card to save them for quick access later.</p>
          <Link to="/factories" className="btn-giwahs btn-giwahs-primary mt-8 inline-flex">Browse factories</Link>
        </div>
        <RecentlyViewedStrip placement="saved-empty" showEmptyState={true} />
      </div>
    );
  }

  return (
    <div data-testid="saved-page" className="bg-white">
      <SEO title="Saved Suppliers" description="Your bookmarked suppliers shortlist." noindex />
      <section className="border-b border-black bg-white">
        <div className="mx-auto max-w-[1440px] px-5 py-12 md:px-8 md:py-16">
          <span className="label-overline">/ Saved Suppliers</span>
          <h1 className="mt-4 font-display tracking-tighter" style={{ fontWeight: 700, fontSize: 'clamp(2.25rem, 5vw, 4.5rem)', lineHeight: 0.95 }}>
            Your shortlist.
          </h1>
          <p className="mt-4 text-neutral-700">{items.length} saved factor{items.length === 1 ? 'y' : 'ies'}. Saved locally in your browser.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-[1440px] px-5 py-10 md:px-8 md:py-14">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {items.map((s, i) => <SupplierCard key={s.id} supplier={s} index={i} />)}
          </div>
        </div>
      </section>

      <RecentlyViewedStrip placement="saved" showEmptyState={true} />
    </div>
  );
};

export default SavedSuppliers;
